import { getRetailerOrBrandToken } from "@faire/help-center-utils/serialized-data/getRetailerOrBrandToken";
import { trackCxFoundationsOrderListPageIssueUnrelatedButtonClick } from "@faire/web-api--source/events/cxFoundations/click/orderListPageIssueUnrelatedButton";

export const trackClickOnIssueUnrelatedToOrder = () => {
  trackCxFoundationsOrderListPageIssueUnrelatedButtonClick(
    getRetailerOrBrandToken()
  );
};
